<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Name:</label>
          </b-col>
          <b-col sm="12">
            <b-form-input id="input-small" v-model="name" size="sm" placeholder="Enter your name"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Description:</label>
          </b-col>
          <b-col sm="12">
            <b-form-textarea id="input-small" v-model="description" size="sm" placeholder="Enter your description"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Sort Order:</label>
          </b-col>
          <b-col sm="12">
            <b-form-input type="number" min="0" v-model="sort_order" id="input-small" size="sm" placeholder="Sort Order"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Is Subcategory :</label>
          </b-col>
          <b-col sm="12">
            <SelectWithSearch :search_api="categories_path.SEARCH_CATEGORY" :selected_data="[parent_id]" selected_by="id" track_by="id" display="name" @selectedOption="((v) => parent_id = v)"></SelectWithSearch>
          </b-col>
        </b-row>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="saveCategory" class="btn btn-success">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {categories_path} from "../../../../path";
import SelectWithSearch from "../Common/SelectWithSearch.vue";

export default {
    name: "add",
    props: ['selectedCategory'],
    data() {
        return {
            name: '',
            description: '',
            sort_order: 1,
            baseUrl: process.env.VUE_APP_API_BACKEND_URL,
            parent_id : null,
        };
    },
    watch: {
        selectedCategory(v) {
            console.log(v);
            this.name = this.selectedCategory.name;
            this.description = this.selectedCategory.description;
            this.sort_order = this.selectedCategory.sort_order;
        }
    },
    computed : {
      categories_path(){
        return categories_path;
      }
    },
    mounted() {
        this.name = this.selectedCategory.name;
        this.description = this.selectedCategory.description;
        this.sort_order = this.selectedCategory.sort_order;
        this.parent_id = this.selectedCategory.parent_id;
    },
    methods: {
        async saveCategory() {
            try {
                let res;
                console.log("hello");
                if (this.selectedCategory && Object.keys(this.selectedCategory).length > 0) {
                    res = await axios.put(this.baseUrl + (this.selectedCategory ? (categories_path.SAVE_CATEGORY + '/' + this.selectedCategory.id) : categories_path.SAVE_CATEGORY), {
                        name: this.name,
                        description: this.description,
                        sort_order: this.sort_order,
                        parent_id : this.parent_id
                    });
                }
                else {
                    res = await axios.post(this.baseUrl + categories_path.SAVE_CATEGORY, {
                        name: this.name,
                        description: this.description,
                        sort_order: this.sort_order,
                        parent_id : this.parent_id
                    });
                }
                console.log(res);
                if (res.data.status == true) {
                    this.$bvToast.toast('Successfully added', {
                        title: `Category added`,
                        variant: 'success',
                        solid: true
                    });
                    this.$bvModal.hide("bv-add-category");
                    this.$emit("update");
                }
            }
            catch (e) {
                console.log(e);
            }
        }
    },
    components: { SelectWithSearch }
}
</script>

<style scoped>

</style>